/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyModel } from '../../models/client-survey-model';
import { UpdateSurveyRequest } from '../../models/update-survey-request';

export interface UpdateSurvey$Json$Params {

/**
 * id of survey to update
 */
  surveyId: number;
  
    /**
     * properties to update survey with
     */
    body?: UpdateSurveyRequest
}

export function updateSurvey$Json(http: HttpClient, rootUrl: string, params: UpdateSurvey$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurvey$Json.PATH, 'put');
  if (params) {
    rb.path('surveyId', params.surveyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyModel>;
    })
  );
}

updateSurvey$Json.PATH = '/api/Survey/{surveyId}';
